module.exports = __webpack_public_path__ + "static/media/burger_white_close.5632c81a.svg";